export const FILEHANDER = {
  methods:{
    /**
     * 获取文件夹类型
     * @param {boolean} type.is_team 团队
     * @param {boolean} type.is_shared 共享
     * @param {number} type.folder_dc_type 文件夹类型
     * @return 文件夹类型
     * */
    getFolderType(type) {
      const normalWeights = 0 // 普通文件夹权重为0
      const shareWeights = type.is_shared ? 1 : 0 // 这个文件夹的共享权重
      const teamWeights = type.is_team ? 2 : 0 // 这个文件夹的团队权重
      const weights = Math.max( // 找到文件夹占权重最大那个，显示具体的图标
        normalWeights,
        shareWeights,
        teamWeights,
      )
      let typeIconName = 'folder'
      switch (weights) {
        case 0:
          break
        case 1:
          typeIconName = 'folder-share'
          break
        case 2:
          typeIconName = 'folder-team'
          break
        default:
          break
      }
      return typeIconName
    },
  }
}
